import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines class names using clsx and merges them with tailwind-merge.
 * This ensures that Tailwind CSS classes are properly merged and conflicts are resolved.
 *
 * @param inputs - Class names to be combined and merged.
 * @returns The combined and merged class names as a single string.
 */
export const cn = (...inputs: ClassValue[]) => {
	return twMerge(clsx(inputs));
};
